export default "__VITE_ASSET__DDplrUWi__"